import { render, staticRenderFns } from "./DataMaster.vue?vue&type=template&id=7f451976&lang=pug"
import script from "./DataMaster.vue?vue&type=script&lang=js"
export * from "./DataMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports